import React from 'react';
import './styles/LoadingIndicator.scss';

const LoadingIndicator = ({ className, containerClassName, label, border }) => {
  return (
    <>
      <div
        className={`Loading-Container ${
          containerClassName ? containerClassName : ''
        } ${border ? 'border' : ''}`}
      >
        <div
          className={`d-flex justify-content-center ${
            className ? className : ''
          }`}
        >
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
        {label && (
          <div className="text-center">
            <p className="fs-4">{label}</p>
          </div>
        )}
      </div>
    </>
  );
};

export default LoadingIndicator;
